export default __webpack_public_path__ + "static/media/nfo_title_icon.276525f8.svg";